import {ItemsTreeResponse} from '@hconnect/uikit'
import {CardBox, VerticalNavigationTree} from '@hconnect/uikit/src/lib2'
import {Box, SxProps, Theme} from '@mui/material'
import {useEffect, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {CqdbEquipmentDto} from '../../types'

type Props = {
  labData?: CqdbEquipmentDto[]
  isLoading: boolean
  isFetching: boolean
  selectedItem?: string
  onItemChange: (item: string) => void
  cardBoxSx?: SxProps<Theme>
}

export const LabQualityResultNavigation: React.FC<Props> = ({
  labData,
  isLoading,
  isFetching,
  selectedItem,
  onItemChange,
  cardBoxSx
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const noDataLabel = t('eventsTable.noData')
  const noResultLabel = t('labQualityResult.noResult')

  const tree = useMemo(() => {
    if (!labData) {
      return {items: []} as ItemsTreeResponse
    }

    return {
      items: labData.map((equipment, index) => ({
        id: equipment.limsSamplingPointCode,
        name: equipment.hasMeasurementData
          ? equipment.limsSamplingPointCode
          : `${equipment.limsSamplingPointCode} (${noResultLabel})`,
        order: index + 1
      }))
    } as ItemsTreeResponse
  }, [labData, noResultLabel])

  const firstItemId = useMemo(
    () => (tree.items.length > 0 ? tree.items[0].id : undefined),
    [tree.items]
  )

  useEffect(() => {
    if (!selectedItem && firstItemId) {
      onItemChange(firstItemId)
    }
  }, [firstItemId, onItemChange, selectedItem])

  return (
    <CardBox
      sx={{width: '100%'}}
      style={{padding: 'unset'}}
      data-test-id="lab-quality-result-navigation"
    >
      <Box
        sx={{
          ...cardBoxSx,
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          flexWrap: 'wrap',
          ...(tree.items.length === 0 && {minHeight: 'calc(100vh - 200px)'}) // expand to full height if no data
        }}
      >
        <VerticalNavigationTree
          oldStructure={false}
          isFetching={isFetching}
          isLoading={isLoading}
          tree={tree}
          selectedResourceId={selectedItem}
          setSelectedResource={onItemChange}
          selectedDate={''}
          noDataLabel={noDataLabel}
        />
      </Box>
    </CardBox>
  )
}
